module.exports = new __parcel__URL__("add-on-v1.2ff8363f.svg").toString();